/**
 * Segment API Keys
 *
 * These are client-side keys, so they are safe to include in Javascript we send to customers.
 */
export const SEGMENT_PRODUCTION_KEY = 'KmsphFvKHKQEkgcdP2WaewtzyYPWY4vI'; // Golden Gate prod environment
export const SEGMENT_STAGING_KEY = '0eY6ZjxyHlN0Zf0aPgCLDJ1RKo2nch3g'; // Golden Gate QA and staging environments
//# sourceMappingURL=segmentApiKeysConsts.js.map